export const training = {
    namespaced: true,
    state: {
        webinars: [
            {
                "poster": require('./images/1701.png'),
                "date": "2015-09-09",
                "title": "Проверка контрагента по кредитной истории",
                "link": "http://www.unirate24.ru/proverka-kontragenta-po-kreditnoj-istorii"
            },
            {
                "poster": require('./images/1702.png'),
                "date": "2015-11-19",
                "title": "Проверка персонала по кредитной истории",
                "link": "http://www.unirate24.ru/proverka-personala"
            },
            {
                "poster": require('./images/1703.png'),
                "date": "2015-10-23",
                "title": "Проверка юридических лиц по кредитной истории",
                "link": "http://www.unirate24.ru/proverka-juridicheskih-lic"
            },
            {
                "poster": require('./images/1704.png'),
                "date": "2015-09-09",
                "title": "Проверка контрагентов по кредитной истории",
                "link": "http://www.unirate24.ru/proverka-kontragentov-po-kreditnoj-istorii"
            },
            {
                "poster": require('./images/1705.png'),
                "date": "2015-07-10",
                "title": "Оценка физических лиц по кредитной истории",
                "link": "http://www.unirate24.ru/vebinar-kreditnaya-istoriya-fiz-lic"
            },
            {
                "poster": require('./images/1706.png'),
                "date": "2015-03-31",
                "title": "Кредитная история. Новый инструмент проверки",
                "link": "http://www.unirate24.ru/vebinar-kreditnaya-istoriya"
            },

        ],
        presentations: [
            {
                "poster": require('./images/1707.png'),
                "title": "Парнерская программа",
                "link": "https://my.unirate24.ru/Doc/Training/Pres/UR24_Partner_programm_2016.pdf"
            },
            {
                "poster": require('./images/1708.png'),
                "title": "О сервисе Unirate24.ru",
                "link": "https://my.unirate24.ru/Doc/Training/Pres/UR24_About_18032016.pdf"
            },
            {
                "poster": require('./images/1709.png'),
                "title": "Управление дебиторской задолженностью",
                "link": "https://my.unirate24.ru/Doc/Training/Pres/%D0%AE%D0%A024_Receivables_2204.pdf"
            }
        ]
    },
    getters: {
        webinars({ webinars }) {
            return webinars.sort((a, b) => {
                switch (true) {
                    case a.date > b.date:
                        return 1;
                    case a.date < b.date:
                        return -1;
                    default:
                        return 0;
                }
            });
        },
        presentations({ presentations }) {
            return presentations;
        },
        allMaterials(state, { webinars, presentations }) {
            return webinars.concat(presentations);
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/training/store.js